import { FilterArea } from "#src/components/FilterArea";
import {
  DateSelectorInput,
  DropdownInput,
  type StorageKeys,
} from "@validereinc/common-components";
import {
  JobGetListFilterSchema,
  JobStatusType,
  JobTypes,
  JobTypeType,
} from "@validereinc/domain";
import { endOfDay, subDays } from "date-fns";
import React from "react";

const defaultRetentionWindowInDays = 30;
const defaultDateRange = {
  from: subDays(new Date(), defaultRetentionWindowInDays),
  to: endOfDay(new Date()),
};

export const RunLogFilterArea = ({
  viewConfigStorageKey,
}: Pick<StorageKeys, "viewConfigStorageKey">) => {
  return (
    <FilterArea.Root<{
      started_at: { from: Date; to: Date };
    }>
      storageKey={viewConfigStorageKey}
      defaultValues={{
        started_at: defaultDateRange,
      }}
    >
      <FilterArea.Container>
        <FilterArea.Content>
          {({ handleOnChange }) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginBottom: 16,
              }}
            >
              <DateSelectorInput
                name={JobGetListFilterSchema.keyof().Enum.started_at}
                label="Started At"
                variant="day"
                isRange
                isInline
                isLabelShown={false}
                max={defaultDateRange.to}
                onChange={(val) => handleOnChange(val, "started_at")}
              />
              <DropdownInput
                name={JobGetListFilterSchema.keyof().Enum.status}
                label="status"
                placeholder="Select Status..."
                options={[
                  { name: "Completed", id: "finished" },
                  { name: "Failed", id: "failed" },
                  { name: "Partial", id: "partial" },
                  { name: "In-Progress", id: "started" },
                ]}
                labelKey="name"
                valueKey="id"
                isLabelShown={false}
                isInline
                onChange={(val: JobStatusType) => handleOnChange(val, "status")}
              />
              <DropdownInput
                name={JobGetListFilterSchema.keyof().Enum.type}
                label="Run Type"
                placeholder="Select Run Type..."
                options={[
                  {
                    name: "Record Automation",
                    id: JobTypes.APPLY_RECORD_CONFIGURATION,
                  },
                  {
                    name: "Estimation Method Configuration",
                    id: JobTypes.APPLY_CALCULATOR_CONFIGURATION,
                  },
                  { name: "Calculation Run", id: JobTypes.RUN_CALCULATION },
                  {
                    name: "Configuration and Calculation Run",
                    id: JobTypes.APPLY_DEFAULT_CALCULATOR_CONFIGURATION_AND_RUN_CALCULATION,
                  },
                  {
                    name: "Seeded Record Automation",
                    id: JobTypes.APPLY_DEFAULT_RECORDS_BY_CONFIG_FILTER,
                  },
                ]}
                labelKey="name"
                valueKey="id"
                isLabelShown={false}
                isInline
                onChange={(val: JobTypeType) => handleOnChange(val, "type")}
              />
            </div>
          )}
        </FilterArea.Content>
      </FilterArea.Container>
    </FilterArea.Root>
  );
};
